<template>
  <v-container fluid grid-list-xs fill-height>
    <v-layout row wrap>
        <v-flex sm3 md3>
          <sidebar/>
        </v-flex>
        <v-flex sm9 md9>
          <router-view/>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Sidebar from './Sidebar'

export default {
  components: {
    Sidebar
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/index.vue